import classNames from 'classnames';
import React from 'react';
import { Icon } from 'ui';
import { isMobileDevice } from 'utils/browserCheck';
import FeatureFlag from 'components/shared/FeatureFlag';

const isIOS = () =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

const isAndroid = () => /(android)/i.test(navigator.userAgent);
const isDesktop = () => !isIOS() && !isAndroid();

const attendanceText = (attendance, pastEvent) => {
  if (pastEvent) {
    return attendance.did_attend || attendance.didAttend
      ? t('in_person_training.attendance.phrase.did_attend')
      : t('in_person_training.attendance.phrase.did_not_attend');
  }
  return attendance.rsvp_status === 'will_attend' ||
    attendance.rsvpStatus === 'will_attend'
    ? t('in_person_training.attendance.phrase.will_attend')
    : t('in_person_training.attendance.phrase.will_not_attend');
};

const mobileAttendanceText = (attendance, pastEvent) => {
  if (pastEvent) {
    return attendance.did_attend || attendance.didAttend
      ? t('in_person_training.attendance.phrase.mobile_did_attend')
      : t('in_person_training.attendance.phrase.mobile_did_not_attend');
  }
  return attendance.rsvp_status === 'will_attend' ||
    attendance.rsvpStatus === 'will_attend'
    ? t('in_person_training.attendance.phrase.mobile_will_attend')
    : t('in_person_training.attendance.phrase.mobile_will_not_attend');
};

const AttendanceStatus = ({
  attendance,
  isRsvpTypeAll,
  pastEvent,
  showSessionAtCapacityNotice = false,
}) => {
  let statusClass;
  let statusText;
  let mobileStatusText;
  let statusIcon;

  if (showSessionAtCapacityNotice) {
    statusIcon = 'info';
    statusClass = 'blue';
    statusText = t('in_person_training.attendance.phrase.at_capacity');
  } else {
    const status = pastEvent
      ? attendance.did_attend ||
        attendance.didAttend ||
        ['will_attend', 'did_attend'].includes(attendance.status)
      : attendance.rsvp_status === 'will_attend' ||
        attendance.rsvpStatus === 'will_attend' ||
        ['did_attend', 'will_attend'].includes(attendance.status);
    if (status) {
      statusClass = 'attending';
      statusIcon = 'correct';
    } else {
      statusClass = 'notAttending';
      statusIcon = 'incorrect';
    }

    statusText = attendanceText(attendance, pastEvent);
    mobileStatusText = mobileAttendanceText(attendance, pastEvent);
  }

  return (
    <>
      <div
        className={classNames(
          `EventRegistration-AttendanceStatus
        EventRegistration-AttendanceStatus--${statusClass}
        mr-16
        `,
          {
            'RsvpTypeAll-status': isRsvpTypeAll,
          },
        )}
      >
        <Icon name={statusIcon} className="EventRegistration-AttendanceIcon" />
        <div className="EventRegistration-AttendanceStatus desktop">
          {statusText}
        </div>
        <div className="EventRegistration-AttendanceStatus mobile">
          {mobileStatusText}
        </div>
      </div>
      <FeatureFlag features="events_in_development">
        {isDesktop() === true &&
          isRsvpTypeAll &&
          attendance.rsvp_status === 'will_not_attend' &&
          isMobileDevice() === false && (
            <div className="EventRegistration-divider mr-16" />
          )}
      </FeatureFlag>
    </>
  );
};

export default AttendanceStatus;
